import type { Story } from '@/store/story-types'

export const K_FASHION_STORE_STORY: Story = {
  id: 'k-fashion-store',
  name: 'KMODE — Korean Fashion Store',
  narrative: 'A Korean fashion e-commerce store with trending collections, editorial lookbooks, product details, and a full cart-to-checkout flow.',
  goals: ['Browse trending K-fashion items', 'Explore editorial lookbooks', 'View product details and select options', 'Add to cart and complete checkout'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 5, linkedPageId: 'home',
      description: 'Landing page with navbar, hero banner, trending grid, editorial section, and footer',
      blockRef: { category: 'fashion', blockId: 'kf-hero' },
    },
    {
      id: 'pg-product-detail', title: 'Product Detail', order: 1, status: 'draft', elementCount: 3, linkedPageId: 'product-detail',
      description: 'Product detail page with images, size selector, price, and add-to-cart button',
      blockRef: { category: 'fashion', blockId: 'kf-product-detail' },
    },
    {
      id: 'pg-cart', title: 'Cart', order: 2, status: 'draft', elementCount: 3, linkedPageId: 'cart',
      description: 'Shopping cart with item list, quantity controls, and subtotal in KRW',
      blockRef: { category: 'fashion', blockId: 'cart-view' },
    },
    {
      id: 'pg-checkout', title: 'Checkout', order: 3, status: 'draft', elementCount: 3, linkedPageId: 'checkout',
      description: 'Checkout page with shipping address, payment method, and order confirmation',
      blockRef: { category: 'fashion', blockId: 'kf-checkout' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Trending K-Fashion',
      description: 'Visitor browses trending Korean fashion items on the home page',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'a hero banner, trending items grid, and editorial section are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'View Product Detail',
      description: 'Visitor taps a fashion item to see its details',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'they tap a product card' },
        { type: 'then', text: 'the product detail page shows images, size options, price, and add-to-cart button', linkedPageId: 'product-detail' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Add to Cart',
      description: 'Visitor adds a fashion item to the cart',
      steps: [
        { type: 'given', text: 'the visitor is on the product detail page', linkedPageId: 'product-detail' },
        { type: 'when', text: 'they select a size and tap Add to Cart' },
        { type: 'then', text: 'the cart badge updates and the item appears in the cart', linkedPageId: 'cart' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Complete Checkout',
      description: 'Visitor completes the checkout with shipping and payment',
      steps: [
        { type: 'given', text: 'the visitor has items in the cart', linkedPageId: 'cart' },
        { type: 'when', text: 'they proceed to checkout' },
        { type: 'then', text: 'a checkout form with shipping address and payment fields is displayed', linkedPageId: 'checkout' },
        { type: 'and', text: 'the total is shown in KRW and the form validates before submission', linkedFlowId: 'validateCheckout' },
      ],
    },
  ],
}
